/* SanitairLuxe 2026-10-01 — SET-productpagina's (template complete-set):
   vaste koopbalk (#SlStickyBuy, uit snippets/sl-pdp-polish.liquid) met hetzelfde gedrag als de
   standaard productpagina:
   - telefoon: balk staat bij openen al onderin, verdwijnt zodra de echte knop in beeld komt,
     en komt terug zodra je voorbij de knop scrolt;
   - laptop: balk verschijnt pas als je voorbij de knop bent.
   Klikken op de balk = klikken op de echte knop (dat regelt sl-pdp-polish al).
   Alleen geladen op template 'complete-set' (via layout/theme.liquid). */
(function () {
  if (window.__slSetBuyBar) return;
  window.__slSetBuyBar = true;
  var mq = window.matchMedia('(max-width: 767px)');
  var ticking = false;
  var liftByUs = false;
  var variants = {};
  try {
    var node = document.getElementById('SlPdpVariants');
    if (node) variants = JSON.parse(node.textContent) || {};
  } catch (e) { variants = {}; }

  function visible(el) { return !!(el && el.offsetHeight > 0 && el.offsetWidth > 0); }
  function previewOffset() {
    var pb = document.getElementById('preview-bar-iframe');
    if (!visible(pb)) return 0;
    var r = pb.getBoundingClientRect();
    return r.bottom >= window.innerHeight - 4 ? Math.round(r.height) : 0;
  }
  function mainButton() {
    return document.querySelector('.slx-product-page .slx-form-actions .slx-atc-btn') || document.querySelector('.slx-atc-btn');
  }
  function updateVariant(bar) {
    var input = document.querySelector('form.slx-form input[name="id"]');
    var v = input && variants[input.value];
    if (!v) return;
    var price = bar.querySelector('[data-sl-sticky-price]');
    if (price && price.textContent !== v.price) price.textContent = v.price;
    var btn = bar.querySelector('[data-sl-sticky-btn]');
    if (btn) btn.disabled = !v.available;
  }
  function run() {
    ticking = false;
    var bar = document.getElementById('SlStickyBuy');
    var btn = mainButton();
    if (!bar || !btn) return;
    var off = mq.matches ? previewOffset() : 0;
    bar.style.bottom = off ? off + 'px' : '';
    var barH = bar.offsetHeight || 66;
    var r = btn.getBoundingClientRect();
    var passed = r.height > 0 && r.bottom < 0;
    var before = mq.matches && r.height > 0 && r.top > window.innerHeight - off - barH + 2;
    var show = passed || before;
    if (bar.classList.contains('is-visible') !== show) bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('sl-sticky-buy-on', passed);
    if (show) {
      updateVariant(bar);
      document.documentElement.style.setProperty('--sl-sticky-h', Math.round(barH + off) + 'px');
      if (!document.body.classList.contains('sl-lift-on')) {
        document.body.classList.add('sl-lift-on');
        liftByUs = true;
      }
    } else if (liftByUs) {
      document.body.classList.remove('sl-lift-on');
      liftByUs = false;
    }
  }
  function queue() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(run);
  }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  window.addEventListener('load', function () { queue(); setTimeout(queue, 400); setTimeout(queue, 1600); setTimeout(queue, 4200); });
  document.addEventListener('product:variant-change', function () { setTimeout(queue, 300); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('form.slx-form')) setTimeout(queue, 300);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue); else queue();
})();
